import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { localStorageSetItem } from "../App";

const useSavePreviousPath = () => {
  const location = useLocation();
  const prevLocation = useRef(location.pathname + location.search); // Include query parameters

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      localStorageSetItem("preAuthPath", prevLocation.current);
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    // Update previous location only when location changes
    const currentPath = location.pathname + location.search;
    if (currentPath !== prevLocation.current) {
      localStorageSetItem("preAuthPath", prevLocation.current);
      prevLocation.current = currentPath;
    }

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [location]);

  // Optionally return the previous path for immediate access
  return prevLocation.current;
};

export default useSavePreviousPath;
